import React from 'react'
import styled, { css } from 'styled-components'

/**
 * Bootstrap 아이콘 기반
 */
const IconCircle = styled.i.attrs(({ className }) => ({
  className: `bi ${className || ''}`.trim()
}))`
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    background-color: var(--deep-dark-color);
    color: var(--light-color);
    border-radius: 50%;
    font-size: 1.6rem;
    transition: background-color 0.2s, color 0.2s;

    &:hover {
        background-color: var(--deep-color);
        color: var(--base-light-color);
        cursor: pointer;
    }

    ${props => props.disabled && css`
        background-color: var(--gray-color);
        color: var(--lightgray-color);
        cursor: not-allowed;
        pointer-events: none;
    `}
`

export default IconCircle